import { Tooltip as MUITooltip, TooltipProps } from '@material-ui/core';

export default function Tooltip({
  children,
  ariaHidden,
  ...props
}: { children: React.ReactNode; ariaHidden: boolean } & TooltipProps) {
  const mergedPopperProps = {
    ...(props.PopperProps || {}),
    ...(ariaHidden ? { 'aria-hidden': true } : {}),
  };

  return (
    <MUITooltip
      {...props}
      PopperProps={mergedPopperProps}
      {...(ariaHidden
        ? {
            'aria-describedby': void 0,
          }
        : {})}
    >
      {children}
    </MUITooltip>
  );
}
